/* Generated from avid-portal-v2/src/lib/catalog-fitment-rules.ts.
 * Source SHA256: ba011a95eff5c4ed54e2b84c66c7c04e1805578f4dc4b1539d24055a748ba8c1
 * Edit the Portal source and regenerate; this is not a second fitment authority. */
(function(root) {
  const exports = {};
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CATALOG_FITMENT_CONTRACT_VERSION = void 0;
exports.validateCatalogFitmentRule = validateCatalogFitmentRule;
exports.catalogFitmentYearMatches = catalogFitmentYearMatches;
exports.catalogFitmentConfigurationKey = catalogFitmentConfigurationKey;
exports.catalogFitmentScopeMatches = catalogFitmentScopeMatches;
exports.evaluateCatalogFitment = evaluateCatalogFitment;
exports.evaluateProjectedCatalogFitment = evaluateProjectedCatalogFitment;
exports.catalogFitmentRuleLabel = catalogFitmentRuleLabel;
exports.catalogFitmentDiscoveryFacets = catalogFitmentDiscoveryFacets;
/** Catalog-owned compatibility. Shared by authoring, publication and consumers. */
exports.CATALOG_FITMENT_CONTRACT_VERSION = 1;
const uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
function validateCatalogFitmentRule(rule) {
    const errors = [];
    if (!uuid.test(rule.modelId))
        errors.push("Select a canonical vehicle model.");
    if (!["years", "range", "current"].includes(rule.yearMode))
        errors.push("Select a year mode.");
    const yearValid = (year) => Number.isInteger(year) && year >= 1900 && year <= 2200;
    if (!yearValid(rule.yearStart))
        errors.push("A valid starting year is required.");
    if (rule.yearMode === "years" && (!rule.years.length || rule.years.some((year) => !yearValid(year))))
        errors.push("Select at least one valid model year.");
    if (rule.yearMode === "years" && rule.years.length && rule.yearStart !== Math.min(...rule.years))
        errors.push("The starting year must match the earliest selected year.");
    if (rule.yearMode === "range" && (!yearValid(rule.yearEnd ?? 0) || rule.yearEnd < rule.yearStart))
        errors.push("The ending year must be on or after the starting year.");
    if (rule.yearMode === "current" && rule.yearEnd !== null)
        errors.push("Current must not have a fixed ending year.");
    if (!["selected", "all", "unspecified"].includes(rule.submodelMode))
        errors.push("Select a submodel mode.");
    if (rule.submodelMode === "selected" && (!rule.submodelIds.length || rule.submodelIds.some((id) => !uuid.test(id))))
        errors.push("Select at least one canonical submodel.");
    if (rule.submodelMode !== "selected" && rule.submodelIds.length)
        errors.push("Selected submodels must be empty for this mode.");
    if (rule.applicationIds.some((id) => !uuid.test(id)))
        errors.push("An application identity is invalid.");
    if (rule.generationId && !uuid.test(rule.generationId))
        errors.push("The generation identity is invalid.");
    if (rule.approvalStatus === "approved" && (!rule.sourceLocator.trim() || !["source_exact", "avid_measured"].includes(rule.confidence)))
        errors.push("Approval requires exact source or AVID evidence and its locator.");
    if (rule.approvalStatus === "approved" && rule.status === "pending_review")
        errors.push("Choose a compatibility result before approval.");
    return errors;
}
function catalogFitmentYearMatches(rule, year) {
    if (!Number.isInteger(year) || year < 1900 || year > 2200)
        return false;
    if (rule.yearMode === "years")
        return rule.years.includes(year);
    return year >= rule.yearStart && (rule.yearMode === "current" || (rule.yearEnd !== null && year <= rule.yearEnd));
}
function jsonEqual(left, right) {
    if (left === right)
        return true;
    if (Array.isArray(left) && Array.isArray(right))
        return left.length === right.length && left.every((item, index) => jsonEqual(item, right[index]));
    if (left && right && typeof left === "object" && typeof right === "object" && !Array.isArray(left) && !Array.isArray(right)) {
        const a = left, b = right;
        return Object.keys(a).length === Object.keys(b).length && Object.keys(a).every((key) => Object.hasOwn(b, key) && jsonEqual(a[key], b[key]));
    }
    return false;
}
function catalogFitmentConfigurationKey(configuration) {
    const sorted = (value) => Array.isArray(value) ? value.map(sorted)
        : value && typeof value === "object" ? Object.fromEntries(Object.entries(value).sort(([a], [b]) => a.localeCompare(b)).map(([key, item]) => [key, sorted(item)])) : value;
    return JSON.stringify(sorted(configuration));
}
function catalogFitmentScopeMatches(rule, vehicle) {
    if (rule.status === "retired" || rule.modelId !== vehicle.modelId || !catalogFitmentYearMatches(rule, vehicle.year))
        return false;
    // Migrated assertions retain their exact application scope until explicitly edited.
    if (rule.applicationIds.length && !rule.applicationIds.includes(vehicle.applicationId))
        return false;
    if (rule.generationId && rule.generationId !== vehicle.generationId)
        return false;
    if (rule.submodelMode === "selected" && (!vehicle.submodelId || !rule.submodelIds.includes(vehicle.submodelId)))
        return false;
    if (rule.submodelMode === "unspecified" && vehicle.submodelId !== null)
        return false;
    return Object.entries(rule.configuration).every(([key, value]) => Object.hasOwn(vehicle.configuration, key) && jsonEqual(value, vehicle.configuration[key]));
}
function evaluateCatalogFitment(rules, vehicle) {
    const result = evaluateProjectedCatalogFitment(rules.map(rule => ({
        ...rule,
        evidenceCurrent: rule.evidenceCurrent && Boolean(rule.reviewedAt && rule.sourceLocator.trim() && ["source_exact", "avid_measured"].includes(rule.confidence)),
    })), vehicle);
    if (result.outcome === "incompatible")
        result.reasons = result.ruleIds.map(id => rules.find(rule => rule.id === id)?.notes || "This configuration is excluded.");
    return result;
}
/** Public projections already carry the server-computed evidence gate. */
function evaluateProjectedCatalogFitment(rules, vehicle) {
    const unknown = (reason, ruleIds = []) => ({ outcome: "unknown", ruleIds, conditions: [], reasons: [reason] });
    if (!vehicle.identityConfirmed)
        return unknown("The vehicle identity needs review.");
    const matches = rules.filter((rule) => catalogFitmentScopeMatches(rule, vehicle));
    if (matches.some(rule => rule.status === "incompatible" && rule.approvalStatus !== "rejected" && !rule.evidenceCurrent))
        return unknown("A matching exclusion needs review before compatibility can be confirmed.", matches.map(rule => rule.id));
    const approved = matches.filter((rule) => rule.evidenceCurrent === true && rule.approvalStatus === "approved");
    if (!approved.length)
        return unknown("No approved compatibility rule matches this vehicle.", matches.map((rule) => rule.id));
    const exclusions = approved.filter((rule) => rule.status === "incompatible");
    if (exclusions.length)
        return { outcome: "incompatible", ruleIds: exclusions.map((rule) => rule.id), conditions: [], reasons: ["This configuration is excluded."] };
    const positives = approved.filter((rule) => ["confirmed", "conditional"].includes(rule.status));
    if (!positives.length)
        return unknown("The matching rules do not approve compatibility.", approved.map((rule) => rule.id));
    // Free-text requirements/exclusions cannot be treated as machine-satisfied.
    const conditions = [...new Set(positives.flatMap((rule) => [...rule.requirements, ...rule.modifications, ...rule.exclusions]))];
    const conditional = positives.some((rule) => rule.status === "conditional") || conditions.length > 0;
    return { outcome: conditional ? "conditional" : "compatible", ruleIds: positives.map((rule) => rule.id), conditions, reasons: [] };
}
function catalogFitmentRuleLabel(rule) {
    const years = rule.yearMode === "current" ? `${rule.yearStart} to Current`
        : rule.yearMode === "years" ? [...rule.years].sort((a, b) => a - b).join(", ")
            : rule.yearStart === rule.yearEnd ? String(rule.yearStart) : `${rule.yearStart}-${rule.yearEnd}`;
    const submodels = rule.submodelMode === "all" ? "All submodels"
        : rule.submodelMode === "unspecified" ? "Submodel not specified in source" : rule.submodelLabels.join(", ");
    return [rule.make, rule.model, years, submodels].filter(Boolean).join(" · ");
}
/** Discovery facets describe candidate scope. They never assert compatibility. */
function catalogFitmentDiscoveryFacets(rules, currentYear = new Date().getUTCFullYear()) {
    return rules.filter(rule => rule.status !== "retired" && rule.status !== "incompatible" && rule.approvalStatus !== "rejected").flatMap(rule => {
        const end = Math.min(rule.yearMode === "current" ? currentYear + 1 : rule.yearEnd ?? rule.yearStart, 2200);
        const years = rule.yearMode === "years" ? [...rule.years] : Array.from({ length: Math.max(0, end - rule.yearStart + 1) }, (_, i) => rule.yearStart + i);
        const submodels = rule.submodelMode === "selected" ? rule.submodelIds.map((id, index) => ({ id, label: rule.submodelLabels[index] || "Submodel needs review" }))
            : [{ id: rule.submodelMode === "all" ? "*" : "unspecified", label: rule.submodelMode === "all" ? "All submodels" : "Submodel not specified" }];
        return submodels.map(submodel => ({ ruleId: rule.id, modelId: rule.modelId, make: rule.make, model: rule.model,
            submodelId: submodel.id, submodel: submodel.label, years: years.map(String), position: rule.position,
            configuration: rule.configuration, requirements: rule.requirements, modifications: rule.modifications, exclusions: rule.exclusions,
            evidenceCurrent: rule.evidenceCurrent, approvalStatus: rule.approvalStatus }));
    });
}

  root.AvidCatalogFitment = Object.freeze(exports);
  if (typeof module !== 'undefined' && module.exports) module.exports = exports;
})(typeof globalThis !== 'undefined' ? globalThis : this);
